import React, { useRef, useState } from 'react';
import { useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useInView } from "react-intersection-observer";
import { postJson } from '../../../../utils/utils';
import { deviceTypes } from '../../../../enums/deviceTypes';
import { aICompetitionProvidersTypes } from '../../../../enums/aICompetitionProvidersTypes';
import { setUpdateDigitalView } from '../../../../store/assessments-actions';
import pathRouts from '../../../../enums/pathRoute';
import CarouselElem from '../../../ui/carousel/Carousel';
import BackdropPopup from '../../../ui/backdropPopup/BackdropPopup';
import digitalCuratorshipTypes from '../../../../enums/digitalCuratorshipTypes';
import DigitalCuratorshipItem from '../digitalCuratorshipItem/DigitalCuratorshipItem';
import classes from './DigitalCuratorshipResult.module.css';

const DigitalCuratorshipResult = ({ largeItems, smallItems }) => {

    const containerRef = useRef();
    const { key } = useLocation();
    const [popupData, setPopupData] = useState(null);
    const [ref, inView] = useInView({ triggerOnce: true });
    const { texts } = useSelector(state => state.translate);
    const { deviceType } = useSelector(state => state.responsive);
    const dispatch = useDispatch()

    const handleOnClick = (challengeId, type, link, skillz) => {
        submitDigitalCuratorship(challengeId, skillz);
        dispatch(setUpdateDigitalView(challengeId));

        switch (type) {
            case digitalCuratorshipTypes.link:
                const newTabLink = `${window.location.origin}${window.config.baseUrl}/${pathRouts.DELAYNAVIGATE.route}/ENCODED_${btoa(encodeURIComponent(link))}`;
                window.open(newTabLink, "_blank");
                break;
            default:
                setPopupData({ link, type });
                break;
        }
    };

    const submitDigitalCuratorship = async (challengeId, skillz) => {
        const digitalCuratorshipProvider = aICompetitionProvidersTypes.digitalCuratorship.providerId;
        const data = {
            challengeId,
            providerId: digitalCuratorshipProvider,
            contestId: window.config.contestId,
            skillz
        }
        await postJson(`${window.config.baseApiUrl}/gamification/api/assessment/submit`, data);
    }

    const generatePopupContent = () => {
        switch (popupData.type) {
            case digitalCuratorshipTypes.youtube:
                return <iframe className={classes.Iframe} ref={ref} src={!inView ? popupData : `${popupData.link.replace("autoplay=1", "autoplay=0")}`} title="YouTube video player" frameBorder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>;
            case digitalCuratorshipTypes.pdf:
                return <iframe className={classes.Iframe} src={`${popupData.link}#toolbar=1&navpanes=1`} title="PDF Viewer"></iframe>;
            default: return '';
        }
    }

    return (
        <>
            <div className={classes.DigitalCuratorshipResult} ref={containerRef}>
                <div className={classes.ResultContent}>
                    {largeItems?.length ?
                        <div className={classes.DigitalCuratorshipCarousel}>
                            <CarouselElem
                                id={`CarouselElem_DigitalCuratorship${key}`}
                                color={"black"}
                                customItemWidth={deviceType !== deviceTypes.mobile ? 319 : 284}
                                dropClassLeftArrow={classes.LeftArrow}
                                dropClassRightArrow={classes.RightArrow}
                                clientWidth={containerRef}>
                                {largeItems.map((card, index) => (
                                    <DigitalCuratorshipItem key={index} {...card} handleOnClick={handleOnClick} />
                                ))}
                            </CarouselElem>
                        </div>
                        : ''}
                    {smallItems?.length ? <div className={classes.Grid}>
                        {smallItems.map((card, index) => (
                            <DigitalCuratorshipItem key={index} {...card} handleOnClick={handleOnClick} />
                        ))}
                    </div> : ''}
                </div>
                <div className={classes.Disclaimer}>
                    {texts.digitalCuratorshipDisclaimer}&nbsp;
                    <a href="mailto:pop@education.gov.il" target="_blank" rel="noreferrer">{texts.currentLink}.</a>
                </div>
            </div>
            {popupData ? <BackdropPopup
                style={{ background: popupData.type === digitalCuratorshipTypes.pdf ? "#6E6E6E" : "#000" }}
                close={() => setPopupData(null)}
                dropClass={classes.DropClassBackdropPopup}
                dropClassClose={classes.DropClassClose}>
                {generatePopupContent()}
            </BackdropPopup> : ''}
        </>
    );
}

export default DigitalCuratorshipResult;